module.exports = __webpack_public_path__ + "static/media/red-timer.266f50bb.png";